import * as Models from 'models';

export const ControlState: Models.ControlState = {
  ACTIVE: 'primary',
  DEFAULT: 'secondary',
  DISABLED: 'disabled',
};
